import { Modal, ModalProps } from '@toggle/design-system';
import classnames from 'classnames';
import React from 'react';

import styles from './ModalLarge.module.scss';

export const ModalLarge = ({ className, children, ...rest }: ModalProps) => (
  <Modal
    data-testid="modal-large"
    {...rest}
    className={classnames(styles.styledModal, className)}
  >
    <div data-testid="modal-large-content" className={styles.content}>
      {children}
    </div>
  </Modal>
);
